<template>
  <section class="ugc-almost-done">
    <h3
      class="ugc-almost-done-title text-center"
    >
      {{ translations.ugcInterModalHeader }}
    </h3>
    <div class="row">
      <p
        v-show="!showOnRepositionWarning"
        :class="['ugc-almost-done-text colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']"
      >
        {{ (activeUGCIndex === 0) ? translations.ugcInterModalDesc1 : translations.modals.addYourImageGallery.addYourImageGalleryAlmostDoneDesc }} {{ nextUGCComponentDisplayName }}
        {{ translations.ugcInterModalDesc2 }}.

        <v-popover
          class="ugc-almost-done-popover"
          placement="top"
          trigger="hover click"
          popoverClass="ugc-almost-done-v-popover"
        >
          <span class="icon-help ugc-help-icon"></span>

          <template slot="popover">
            <div class="ugc-almost-done-popover-content">
              <img :src="placementPopoverImageUrl" />
            </div>
          </template>
        </v-popover>
      </p>
      <p
        v-show="showOnRepositionWarning"
        :class="['ugc-almost-done-text-warning colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']"
      >
        {{ translations.ugcInterModalWarningText }} {{ nextUGCComponentDisplayName }}
        {{ translations.ugcInterModalWarningText2 }}.
      </p>
    </div>
    <div class="row ugc-almost-done-cta-wrapper">
      <button
        v-if="!isSecondaryImage && activeUGCIndex === 0 && !isRepositionWarningFlowActive"
        @click="onUploadAnotherClick"
        :class="['secondary button colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']"
      >
        {{ translations.ugcInterModalUploadAnother }}
      </button>
      <button
        v-if="!isSecondaryImage && activeUGCIndex === 1 && !isRepositionWarningFlowActive"
        @click="onSelectAnotherClick"
        :class="['secondary button colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']"
      >
        {{ translations.modals.addYourImageGallery.addYourImageGallerySelectAnother }}
      </button>
    </div>
    <div class="row ugc-almost-done-cta-wrapper">
      <button
        @click="continueSameImage"
        :class="['secondary button colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']"
      >
        <span v-show="!showOnRepositionWarning">{{
          (activeUGCIndex === 0) ? translations.ugcInterModalSamePhoto : translations.modals.addYourImageGallery.addYourImageGalleryUseSame
        }}</span>
        <span v-show="showOnRepositionWarning">{{
          translations.ugcInterModalRepNextComp
        }}</span>
      </button>
    </div>
    <div
      v-show="!showOnRepositionWarning"
      class="ugc-almost-done-linebreak text-center"
    >
      <span class="ugc-almost-done-linebreak-line"></span>
      <span class="ugc-almost-done-linebreak-text">{{
        translations.ugcInterModalOR
      }}</span>
    </div>
    <div v-show="!showOnRepositionWarning" class="row">
      <p :class="['ugc-almost-done-text colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']">
        {{ translations.ugcInterModalConfirmText }}
      </p>
    </div>

    <div v-show="!showOnRepositionWarning" class="row ugc-almost-done-cta-wrapper">
      <button
        ref="finishButton"
        @click="openConfirmDesign"
        :class="['ugc-almost-done-cta-finish primary button colums small-8 small-centered', enableNewUgcModal ? 'medium-7' : 'medium-5']"
      >
        {{ translations.ugcInterModalFinish }}
      </button>
    </div>
  </section>
</template>

<script>

import almostDone from '@/mixins/UGC/almostDone'

export default {
  name: "UgcAlmostDone",
  mixins: [almostDone],
  mounted () {
    this.$nextTick(() => {
      this.$refs.finishButton.focus();
    });
  },
};
</script>
